// src/pages/AIPage.js – نسخهٔ نهایی با فیکس شدن تکست‌باکس، مارجین بالای موبایل و فاصله از باتم نویگیشن

import React, { useState, useRef, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { useAuthContext } from '../context/AuthContext';
import { BsSend, BsCopy, BsSearch, BsLightbulb, BsX } from 'react-icons/bs';
import { Helmet } from 'react-helmet-async';
import { useNavigate, Link } from 'react-router-dom';
import ContentCard from '../components/Product/ContentCard';
import BookCover from '../components/library/BookCover';
import BookCard from '../components/library/BookCard';
import VerticalContentCard from '../components/Category/VerticalContentCard';

const BG_IMAGE = 'https://s3.afra.kubit.cloud/mahsacanva1365-far-free/AI.png';

// ارتفاع نوارها (فقط به‌عنوان fallback در موبایل)
const TOPBAR_HEIGHT = 56;
const BOTTOMNAV_HEIGHT = 64;

const initialMessage = `سلام. من دستیار هوشمند «فرزانه» هستم، طراحی شده‌ام تا شما را در درک عمیق‌تر دیدگاه‌ها و آثار استاد مصطفی ملکیان همراهی کنم. من با دسترسی به سخنرانی‌ها، کتاب‌ها و مقالات مرتبط، جامع‌ترین پاسخ‌ها را ارائه می‌دهم.

شما می‌توانید در مورد این موارد از من بپرسید:

• مفاهیم اصلی در فلسفه ملکیان (مانند خردورزی، اخلاق، معنویت).
• مطالب ارائه شده در درس‌گفتارها و دوره‌های سایت.
• توصیه کتاب‌ها و مقالات مرتبط با موضوع مورد نظر شما.

برای مثال:

• «در کدام سخنرانی‌ها به آثار میشل فوکو اشاره شده است؟»
• «کدام آثار استاد در ارتباط با روانشناسی مثبت‌نگر است؟»
• «رابطه عقلانیت و معنویت از دیدگاه ایشان چیست؟»

لطفاً پرسش خود را مطرح کنید.`;

// ─────────────────────────────────────────────────────────────────────────────
// پارسر محتوای پیام (بدون تغییر)
// ─────────────────────────────────────────────────────────────────────────────
const CARD_LINK_REGEX = /(?:🎓|📚|🎙️|-)?\s*\[([^\]]+)\]\((\/(?:products|books|media)\/[^)]+)\)/g;
const PAGE_LINK_REGEX = /\[([^\]]+)\]\((\/[^)]+)\)/g;

function stripHtml(str) {
  return str.replace(/<[^>]*>/g, '');
}

function parseMessageContent(rawContent) {
  const content = stripHtml(rawContent);
  const blocks = [];
  const lines = content.split('\n');
  let textBuffer = [];
  let currentCards = [];

  const flushText = () => {
    const txt = textBuffer.join('\n').trim();
    if (txt) blocks.push({ type: 'text', value: txt });
    textBuffer = [];
  };

  const flushCards = () => {
    if (currentCards.length) {
      blocks.push({ type: 'cards', items: currentCards });
      currentCards = [];
    }
  };

  for (const line of lines) {
    CARD_LINK_REGEX.lastIndex = 0;
    const cardMatch = CARD_LINK_REGEX.exec(line);
    if (cardMatch) {
      const title = cardMatch[1].trim();
      const url = cardMatch[2].trim();
      const itemType = url.startsWith('/books/') ? 'book' : 'product';
      flushText();
      currentCards.push({ title, url, itemType });
      continue;
    }

    flushCards();

    PAGE_LINK_REGEX.lastIndex = 0;
    const pageMatch = PAGE_LINK_REGEX.exec(line);
    if (pageMatch) {
      const before = line.slice(0, pageMatch.index).trim();
      if (before) textBuffer.push(before);
      flushText();
      blocks.push({ type: 'link', title: pageMatch[1].trim(), url: pageMatch[2].trim() });
      const after = line.slice(pageMatch.index + pageMatch[0].length).trim();
      if (after) textBuffer.push(after);
    } else {
      textBuffer.push(line);
    }
  }

  flushText();
  flushCards();
  return blocks;
}

function extractSlug(url) {
  const parts = url.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
}

// 🟢 فعال‌سازی مجدد fetch کارت‌ها (نسخهٔ اصلی)
function useCardData(items, token) {
  const [cardData, setCardData] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const cardDataRef = React.useRef(cardData);
  React.useEffect(() => { cardDataRef.current = cardData; }, [cardData]);

  const itemsKey = items ? items.map(i => i.url).join(',') : '';

  React.useEffect(() => {
    if (!items || items.length === 0 || !token) return;

    const missing = items.filter(
      item => !cardDataRef.current[`${item.itemType}:${item.url}`]
    );
    if (missing.length === 0) return;

    setLoading(true);
    const payload = missing.map(item => ({
      type: item.itemType === 'book' ? 'book' : 'product',
      slug: extractSlug(item.url),
      title: item.title,
    }));

    fetch('https://farzaneh.app/api/v1/ai/cards/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ items: payload }),
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data || !data.results) return;
        const map = {};
        missing.forEach((item, idx) => {
          const result = data.results[idx];
          if (result) map[`${item.itemType}:${item.url}`] = result;
        });
        setCardData(prev => ({ ...prev, ...map }));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  // eslint-disable-next-line
  }, [itemsKey, token]);

  return { cardData, loading };
}

// ─── بلوک کارت‌ها با BookCard و VerticalContentCard (عرض نرمال) ───
const CardsBlock = ({ items, token }) => {
  const { cardData } = useCardData(items, token);

  return (
    <div className="flex flex-col gap-3 my-3 w-full">
      {items.map((item, idx) => {
        const key = `${item.itemType}:${item.url}`;
        const data = cardData[key] || {
          type: item.itemType,
          slug: extractSlug(item.url),
          title: item.title,
          cover_url: null,
          url: item.url,
        };

        if (item.itemType === 'book') {
          return (
            <div key={idx} className="w-full">
              <BookCard
                book={{
                  slug: data.slug || extractSlug(item.url),
                  title: data.title || item.title,
                  cover_image_url: data.cover_url || '',
                  author: data.author ? { name: data.author } : null,
                  translator: data.translator ? { name: data.translator } : null,
                  publisher: data.publisher ? { title: data.publisher } : null,
                  tags: data.tags || [],
                }}
              />
            </div>
          );
        }

        return (
          <div key={idx} className="w-full">
            <VerticalContentCard
              data={{
                title: data.title || item.title,
                cover_url: data.cover_url || null,
                price_display: data.price_display || '',
                is_free: data.is_free || false,
                description: data.description || '',
                slug: data.slug || extractSlug(item.url),
                product_url: data.url || item.url,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

// ─── لینک قابل‌کلیک برای صفحات عادی (بدون تغییر) ───
const PageLink = ({ title, url }) => (
  <Link
    to={url}
    className="inline-flex items-center gap-1 text-blue-600 underline underline-offset-2 hover:text-blue-800 transition-colors text-sm"
  >
    {title}
  </Link>
);

// ─── انیمیشن انتظار (بدون تغییر) ───
const LoadingDots = () => (
  <div className="flex items-center gap-2 py-1">
    <span className="text-sm text-gray-600">در حال یافتن بهترین پاسخ برای شما هستم</span>
    <span className="flex gap-1">
      {[0, 1, 2].map(i => (
        <span
          key={i}
          className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce"
          style={{ animationDelay: `${i * 0.15}s` }}
        />
      ))}
    </span>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// کامپوننت اصلی
// ─────────────────────────────────────────────────────────────────────────────
const AIPage = () => {
  const { isLoggedIn, openAuthModal, getAuthTokens } = useAuthContext();
  const navigate = useNavigate();

  const [messages, setMessages] = useState(() => {
    try {
      const saved = localStorage.getItem('chatHistory');
      if (saved && JSON.parse(saved).length > 0) return JSON.parse(saved);
      return [{ id: 0, role: 'assistant', content: initialMessage }];
    } catch (e) {
      return [{ id: 0, role: 'assistant', content: initialMessage }];
    }
  });

  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchWeb, setSearchWeb] = useState(false);
  const [deepSearch, setDeepSearch] = useState(true);

  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);
  const abortControllerRef = useRef(null);

  // ── تشخیص container اصلی (برای هماهنگی عرض و موقعیت) ──
  const [containerRect, setContainerRect] = useState(null);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (isMobile) return;

    const update = () => {
      const appContainer =
        document.querySelector('#root > div') ||
        document.querySelector('.app-container') ||
        document.getElementById('root');
      if (appContainer) {
        setContainerRect(appContainer.getBoundingClientRect());
      }
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [isMobile]);

  // 🟢 جلوگیری از اسکرول body هنگام باز بودن صفحه
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('chatHistory', JSON.stringify(messages));
  }, [messages]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // auto-resize textarea
  useEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 140) + 'px';
  }, [input]);

  const getToken = () => {
    try {
      if (getAuthTokens && typeof getAuthTokens === 'function') {
        const tokens = getAuthTokens();
        if (tokens && tokens.access) return tokens.access;
        if (tokens && typeof tokens === 'string') return tokens;
      }
      return localStorage.getItem('access_token') || localStorage.getItem('token');
    } catch (e) {
      console.error('Error getting token:', e);
      return null;
    }
  };

  const sendMessage = async (userMessage, flags = {}) => {
    if (!isLoggedIn) { openAuthModal(); return; }
    const token = getToken();
    if (!token) { openAuthModal(); return; }
    if (!userMessage.trim()) return;

    const userMsgObj = { id: Date.now(), role: 'user', content: userMessage.trim() };
    setMessages(prev => [...prev, userMsgObj]);

    const assistantMsgId = Date.now() + 1;
    setMessages(prev => [...prev, { id: assistantMsgId, role: 'assistant', content: '' }]);
    setIsLoading(true);
    setInput('');

    if (abortControllerRef.current) abortControllerRef.current.abort();
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const response = await fetch('https://farzaneh.app/api/v1/ai/chat/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          query: userMessage,
          search_web: Boolean(flags.searchWeb),
          deep_search: Boolean(flags.deepSearch)
        }),
        signal: abortController.signal
      });

      if (!response.ok) {
        if (response.status === 401) {
          openAuthModal();
          throw new Error('نشست شما منقضی شده است. لطفاً دوباره وارد شوید.');
        }
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedText = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split('\n\n');
        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const data = line.slice(6);
            if (data === '[DONE]') continue;
            try {
              const parsed = JSON.parse(data);
              if (parsed.type === 'meta') continue;
              if (parsed.type === 'sources') continue;
              if (parsed.text) {
                accumulatedText += parsed.text;
                setMessages(prev => prev.map(msg =>
                  msg.id === assistantMsgId ? { ...msg, content: accumulatedText } : msg
                ));
              }
            } catch (e) { /* ignore parse error */ }
          }
        }
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      setMessages(prev => prev.map(msg =>
        msg.id === assistantMsgId
          ? { ...msg, content: `⚠️ خطا: ${error.message || 'مشکل در ارتباط با سرور'}` }
          : msg
      ));
    } finally {
      setIsLoading(false);
      abortControllerRef.current = null;
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (input.trim() && !isLoading) {
      sendMessage(input, { searchWeb, deepSearch });
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  // 🟢 فقط در دسکتاپ منتظر containerRect می‌مانیم
  if (!isMobile && !containerRect) {
    return <div style={{ width: '100vw', height: '100vh' }} />;
  }

  // ═══════════════ تنظیم پرتال ═══════════════
  let portalStyle;
  if (isMobile) {
    portalStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 40,
      overflow: 'hidden',
    };
  } else {
    portalStyle = {
      position: 'fixed',
      top: containerRect.top,
      left: containerRect.left,
      width: containerRect.width,
      height: containerRect.height,
      zIndex: 40,
      overflow: 'hidden',
    };
  }

  // ═══════════════ استایل container داخلی در موبایل ═══════════════
  const innerContainerStyle = isMobile
    ? {
        paddingTop: TOPBAR_HEIGHT,
        paddingBottom: BOTTOMNAV_HEIGHT + 20,   // 🟢 ۲۰px فاصله از باتم نویگیشن
        boxSizing: 'border-box',
      }
    : {};

  return ReactDOM.createPortal(
    <>
      <Helmet>
        <title>دستیار هوشمند | فرزانه</title>
      </Helmet>

      {/* انیمیشن نئون برای حباب‌های دستیار */}
      <style>{`
        @keyframes neonPulse {
          0%, 100% { box-shadow: 0 0 8px rgba(172, 138, 220, 0.33), 0 0 20px rgba(96,165,250,0.3); }
          50% { box-shadow: 0 0 15px rgba(125, 58, 164, 0.39), 0 0 30px rgba(96, 165, 250, 0.31); }
        }
        .neon-glow {
          animation: neonPulse 3s ease-in-out infinite;
        }
      `}</style>

      <div style={portalStyle}>
        {/* تصویر پس‌زمینه + overlay شیشه‌ای (یکسان برای موبایل و دسکتاپ) */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${BG_IMAGE})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 0,
          }}
        />
        <div className="absolute inset-0 bg-white/30 backdrop-blur-l" style={{ zIndex: 1 }} />

        {/* ─── محتوای اصلی ─── */}
        <div
          className="relative flex flex-col h-full w-full"
          style={{ zIndex: 2, ...innerContainerStyle }}
        >
          {/* ناحیه پیام‌ها با کادر شیشه‌ای */}
          <div className="flex-1 overflow-y-auto px-1 py-1 mt-[20px] md:mt-[24px]">
            <div className="p-[10px] bg-white/20 backdrop-blur-md rounded-2xl min-h-full">
              <div className="space-y-4">
                {messages.map((msg) => {
                  const isUser = msg.role === 'user';
                  const blocks = isUser
                    ? [{ type: 'text', value: msg.content }]
                    : parseMessageContent(msg.content);

                  return (
                    <div
                      key={msg.id}
                      className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}
                    >
                      <div
                        className={[
                          'w-fit max-w-[88%] rounded-2xl px-4 py-3 shadow-sm',
                          isUser
                            ? 'bg-white/25 backdrop-blur-lg border border-white/50 text-gray-900 rounded-br-sm'
                            : 'bg-white/30 backdrop-blur-lg border border-blue-200/50 neon-glow text-gray-800 rounded-bl-sm'
                        ].join(' ')}
                      >
                        {/* هدر حباب */}
                        <div className="flex justify-between items-center mb-1.5 text-[11px] opacity-60 gap-4">
                          <span className="font-semibold">{isUser ? 'شما' : 'فرزانه'}</span>
                          {!isUser && msg.content && (
                            <button
                              onClick={() => copyToClipboard(msg.content)}
                              className="hover:opacity-100"
                              aria-label="کپی"
                            >
                              <BsCopy size={12} />
                            </button>
                          )}
                        </div>

                        {/* محتوای حباب */}
                        <div className="text-[11px] leading-7 font-light text-right">
                          {blocks.map((block, i) => {
                            if (block.type === 'cards') {
                              return <CardsBlock key={i} items={block.items} token={getToken()} />;
                            }
                            if (block.type === 'link') {
                              return <PageLink key={i} title={block.title} url={block.url} />;
                            }
                            return (
                              <div
                                key={i}
                                className="whitespace-pre-wrap break-words"
                                style={{ overflowWrap: 'anywhere' }}
                              >
                                {block.value}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* پیام انتظار */}
                {isLoading && (
                  <div className="flex justify-start">
                    <div className="bg-white/40 backdrop-blur-md rounded-2xl px-4 py-3 border border-white/30 shadow-sm">
                      <LoadingDots />
                    </div>
                  </div>
                )}

                <div ref={messagesEndRef} />
              </div>
            </div>
          </div>

          {/* نوار ورودی (بدون sticky – با flex ثابت می‌ماند) */}
          <div
            className="shrink-0 bg-white/60 backdrop-blur-md border-t border-white/30 px-3 pt-3"
            style={{
              paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
            }}
          >
            <div className="flex flex-col gap-2">
              <div className="flex items-end gap-2">
                <textarea
                  ref={textareaRef}
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSubmit(e);
                    }
                  }}
                  placeholder="سوال خود را اینجا بنویسید…"
                  rows={1}
                  className="flex-1 min-h-[48px] max-h-[140px] px-4 py-3 bg-white/80 border border-white/40 rounded-2xl outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all text-sm resize-none leading-6 placeholder:text-gray-500 text-gray-800 backdrop-blur-sm"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={!input.trim() || isLoading}
                  className={`h-[48px] w-[48px] rounded-2xl flex items-center justify-center shrink-0 transition-all duration-200 ${
                    input.trim() && !isLoading
                      ? 'bg-blue-600 hover:bg-blue-700 text-white shadow-md shadow-blue-200 active:scale-95'
                      : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  }`}
                  aria-label="ارسال پیام"
                >
                  <BsSend size={17} />
                </button>
              </div>

              <div className="flex items-center justify-between gap-2 px-0.5">
                <p className="text-[8px] text-gray-500 shrink-0">
                  Enter ارسال &nbsp;·&nbsp; Shift+Enter خط جدید
                </p>
                <div className="flex gap-2">
                  {/* جستجوی اینترنتی */}
                  <button
                    type="button"
                    onClick={() => setSearchWeb(p => !p)}
                    title={searchWeb ? 'جستجوی اینترنتی فعال است' : 'جستجو در اینترنت را فعال کنید'}
                    className={`flex items-center gap-1.5 px-2 py-1.5 rounded-full text-[9px] font-medium transition-all duration-200 select-none ${
                      searchWeb
                        ? 'bg-blue-600 text-white shadow-sm ring-2 ring-blue-200'
                        : 'bg-white/60 border border-white/40 text-gray-600 hover:bg-white'
                    }`}
                  >
                    <BsSearch size={11} />
                    <span>جستجوی وب</span>
                  </button>

                  {/* تفکر عمیق */}
                  <button
                    type="button"
                    onClick={() => setDeepSearch(p => !p)}
                    title={deepSearch ? 'تفکر عمیق فعال است (پیش‌فرض)' : 'تفکر عمیق را فعال کنید'}
                    className={`flex items-center gap-1.5 px-2 py-1.5 rounded-full text-[9px] font-medium transition-all duration-200 select-none ${
                      deepSearch
                        ? 'bg-indigo-600 text-white shadow-sm ring-2 ring-indigo-200'
                        : 'bg-white/60 border border-white/40 text-gray-600 hover:bg-white'
                    }`}
                  >
                    <BsLightbulb size={11} />
                    <span>تفکر عمیق</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default AIPage;